import { useCallback } from 'react'
import { Taxipark } from '~/shared/api'
import { EmptyList } from '~/shared/ui/BalanceList'
import {
  FetchFn,
  Item,
  SCROLLABLE_LIST_META_PAGE,
  ScrollableList,
} from '~/shared/ui/ScrollableList'

import { Card } from './Card'
import { WrapperCard } from './styled'

type Row = Item & {
  name: string
}

type ListTaxiparksUnAuthProps = {
  isManualRegistration?: boolean
}

export function ListTaxiparksUnAuth({
  isManualRegistration = false,
}: ListTaxiparksUnAuthProps) {
  const fetchRows = useCallback<FetchFn<Row>>(async (page, pageSize) => {
    const builder = Taxipark.limit(pageSize)

    const response = await builder.get(page)
    const data = response.getData()

    const items = data.map((taxipark) => {
      return {
        id: taxipark?.getApiId() as string,
        name: taxipark?.getName(),
      }
    })

    const httpClientResponse = response.getHttpClientResponse()
    const axiosResponse = httpClientResponse?.getUnderlying()
    const { to, currentPage, lastPage } =
      axiosResponse?.data?.meta?.page || SCROLLABLE_LIST_META_PAGE

    return {
      items,
      to,
      currentPage,
      lastPage,
    }
  }, [])

  const handleMapItems = useCallback(
    (items: Row[]) => {
      return (
        <>
          {items.map((item) => (
            <WrapperCard key={item.id}>
              <Card {...item} isManualRegistration={isManualRegistration} />
            </WrapperCard>
          ))}
        </>
      )
    },
    [isManualRegistration],
  )

  return (
    <ScrollableList
      queryKey='list-taxiparks-un-auth'
      fetchFn={fetchRows}
      empty={
        <EmptyList
          title='Таксопарки не найдены'
          description='Ошибка получения списка таксопарков'
        />
      }
      mapItems={handleMapItems}
      skeletonItemMarginBottom='16px'
      skeletonHeight={56}
    />
  )
}
